/* eslint-env jquery */
import "node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import "node_modules/cssuseragent/cssua.js";
import Headroom from "../node_modules/headroom.js/dist/headroom.js";
window.Headroom = Headroom;
import "../node_modules/headroom.js/dist/jQuery.headroom.js";
import "node_modules/slick-carousel/slick/slick.js";
import "../node_modules/jquery-inview/jquery.inview.js";
// import '../node_modules/lightbox2/dist/js/lightbox.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

jQuery(function ($) {
  const $nav = $(".pd-main-menu-wrap");
  let isDesktop = window.innerWidth > 991;
  // let isTablet = window.innerWidth < 992 && window.innerWidth > 767;
  let isMobile = window.innerWidth < 991; //768;

  // Navbar Toggles
  function toggleNavbarMethod() {
    if (isDesktop) {
      $(".dropdown")
        // .on("mouseenter", function () {
        .on("mouseover", function () {
          $nav.addClass("menu-open");
          $(this).addClass("show active").attr("aria-expanded", "true");
          $(".dropdown > a").on("click", function () {
            location.href = this.href;
          });
        })
        // .on("mouseleave", function () {
        .on("mouseout", function () {
          $nav.removeClass("menu-open");
          $(this).removeClass("show active").attr("aria-expanded", "false");
        });
    } else {
      // $(".navbar .dropdown").off("mouseover").off("mouseout");
      // $(".navbar .dropdown > a").on("click", function () {
      //   if (!$(this).hasClass("dropdown-open")) {
      //     $(this).addClass("dropdown-open");
      //   }
      // });
      // $(".navbar .dropdown").on(
      //   "click",
      //   function () {
      //     $(this).find(".dropdown-menu").first().stop(true, true);
      //   },
      //   function () {
      //     $(this).find(".dropdown-menu").first().stop(true, true);
      //   }
      // );
    }
  }

  toggleNavbarMethod();
  $(window).on("resize", toggleNavbarMethod);

  // Move search window so it behaves the same as dropdown menus
  $(".pd-nav-search .dropdown-menu").replaceWith($(".nav-search-wrapper"));

  // Hamburgers
  const $hamburger = $(".pd-menu-trigger.hamburger");
  $hamburger.on("click", function () {
    $hamburger.toggleClass("is-active");
    // Toggle Label
    $(".pd-toggle-label").html() == "Close" ? $(".pd-toggle-label").html("Menu") : $(".pd-toggle-label").html("Close");
    $(this).attr("aria-expanded", function (i, attr) {
      return attr == "true" ? "false" : "true";
    });
  });

  // Headroom
  function isNavVisible(nav) {
    return nav.classList.contains("show") ? true : false;
  }

  const nav = document.getElementById("pd-menu-main_menu");
  const options = {
    offset: 100,
    // tolerance: 5
    tolerance: {
      up: 5,
      down: 0,
    },
    // onNotTop: function() {
    //   $('.pd-utility-menu').css('position', 'relative');
    // }
    // onPin : function() {
    //   if ($('.pd-pipeline-table').length) {
    //     $('.pd-pipeline-table thead').css('transform', 'translateY(73px)'); // this is nice but causing overflow
    //   }
    // },
    // onTop : function() {
    //   if ($('.pd-pipeline-table').length) {
    //     // $('.pd-pipeline-table thead').css('transform', 'none');
    //   }
    // },
    onUnpin: function () {
      // if ($('.pd-pipeline-table').length) {
      //   $('.pd-pipeline-table thead').css('transform', 'none');
      // }
      if (isNavVisible(nav)) {
        this.elem.classList.remove(this.classes.unpinned);
        this.elem.classList.add(this.classes.pinned);
      } else {
        this.elem.classList.add(this.classes.unpinned);
        this.elem.classList.remove(this.classes.pinned);
      }
    },
  };
  $(".pd-main-menu-wrap").headroom(options);

  // Scroll to top
  $(".btn-top").on("click", function (e) {
    e.preventDefault();
    if ($(".pd-hero-slider").length) {
      gsap.to($("#pd-content"), {
        duration: 1,
        scrollTo: { y: 0 },
      });
    } else {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  });

  // var $status = $('.pagingInfo');
  var $slickElement = $(".home-panels");

  $slickElement.slick({
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    speed: 500,
    fade: true,
  });

  $(".pd-gallery-slider").slick({
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
    dots: true,
    dotsClass: "slick-dots slick-dots-grey",
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    speed: 500,
    fade: true,
  });

  $(".timeline-slider").slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="slick-next"><path d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
    prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="slick-prev"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    speed: 750,
    fade: false,
  });

  $(".testimonial-slider").slick({
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
    dots: true,
    dotsClass: "slick-dots slick-dots-grey",
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    speed: 500,
    fade: true,
  });

  // Start slick on bootstrap modal slow
  $(".pd-gallery-modal").on("shown.bs.modal", function (e) {
    let target = $(e.target);
    let slideshow = target.find(".pd-modal-gallery-slider");
    target.find(".pd-modal-gallery-slider").not(".slick-initialized").slick({
      autoplay: true,
      autoplaySpeed: 6000,
      arrows: true,
      dots: true,
      dotsClass: "slick-dots slick-dots-white",
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      speed: 500,
      fade: true,
    });
  });

  // Stop slick on bootstrap modal hide
  $(".pd-gallery-modal").on("hidden.bs.modal", function (e) {
    let target = $(e.target);
    target.find(".pd-modal-gallery-slider video").trigger("pause");
    target.find(".pd-modal-gallery-slider").slick("unslick");
  });

  // Hide and show play button and disable slide autoplay on video play
  $(".pd-modal-gallery-slider video").on("pause", function (e) {
    $(e.currentTarget).parent("div").removeClass("playing");
  });
  $(".pd-modal-gallery-slider video").on("play", function (e) {
    $(e.currentTarget).closest(".pd-modal-gallery-slider").slick("slickPause");
    $(e.currentTarget).parent("div").addClass("playing");
  });

  // Pause any videos on slide change
  $(".pd-modal-gallery-slider").on("afterChange", function (event, slick, currentSlide, nextSlide) {
    $(".pd-modal-gallery-slider video").trigger("pause");
  });

  // People bios
  function openBio(thisTarget) {
    let $this = thisTarget;
    let $targetParent = $this.closest(".em-people");
    let $target = $targetParent.find(".em-bio-content");
    let targetOffset = $this.offset().left;
    let $bios = $(".em-people");
    $bios.removeClass("open");
    $targetParent.addClass("open");
    $target.css("margin-left", -targetOffset);
  }

  $(".em-people-link").on("click", function (e) {
    e.preventDefault();
    openBio($(this));
  });

  $(".em-people-close").on("click", function (e) {
    e.preventDefault();
    let $this = $(this);
    let $targetParent = $this.closest(".em-people");
    $targetParent.removeClass("open");
  });

  // Open person bio from URL
  let hash = window.location.hash;
  if (hash) {
    let target = $(hash);
    if (target.hasClass("em-people-wrapper")) {
      openBio(target.find(".em-people-link"));
    }
  }

  // $('.modal-dialog').parent().on('show.bs.modal', function(e){
  //   $(e.relatedTarget.attributes['data-target'].value).appendTo('body');
  // });

  // Pipeline
  function setBarWidths(table) {
    var ths = $(".pd-pipeline-table th.border-left");
    var totalWidth = 0;
    for (var i = 0; i < ths.length; i++) {
      totalWidth += $(ths[i]).outerWidth();
    }

    // calculate px to vw
    // labelCellWidth = $(".pd-pipeline-product-name").outerWidth();
    // widthVw = ( totalWidth - labelCellWidth ) / $(window).width() * 100;

    table.find(".pd-pipeline-graph").each(function () {
      $(this)
        .find(".pd-pipeline-graph-bar")
        .css({
          width: totalWidth + "px",
        });
    });
  }

  function setPipelineProgress(table) {
    const ths = $(".pd-pipeline-table th.border-left");
    let totalWidth = 0;
    for (var i = 0; i < ths.length; i++) {
      totalWidth += $(ths[i]).outerWidth();
    }
    const offset = 6; // 3 is the magic number for modals but we're not doing those anymore

    table.find(".pd-pipeline-graph").each(function () {
      let pct = parseInt($(this).data("pct"));
      let barWidth = (pct / 100) * totalWidth - offset;
      $(this)
        .find(".pd-pipeline-graph-line")
        .css({
          width: barWidth + "px",
        });
    });
  }

  function setPipelineProgressMobile(table) {
    let totalWidth = $(".pd-pipeline-table").outerWidth();
    const offset = 80; // 3 is the magic number
    table.find(".pd-pipeline-graph").each(function () {
      let pct = parseInt($(this).data("pct"));
      let barWidth = (pct / 130) * totalWidth + offset;
      $(this)
        .find(".pd-pipeline-graph-line")
        .css({
          width: barWidth + "px",
        });
    });
  }

  function resetProgress(table) {
    table.find(".pd-pipeline-graph-line").css({
      width: 0,
    });
  }

  const pipelineTable = $(".pd-pipeline-table");

  if (pipelineTable.length) {
    setBarWidths(pipelineTable);
    $(window).on("resize", function () {
      setBarWidths(pipelineTable);
      if (isMobile) {
        setPipelineProgressMobile(pipelineTable);
      } else {
        setPipelineProgress(pipelineTable);
      }
    });
  }

  pipelineTable.one("inview", function (event, isInView) {
    let _this = $(this);
    if (isInView) {
      _this.find(".pd-pipeline-graph-line").addClass("animate");
      setTimeout(function () {
        if (isMobile) {
          setPipelineProgressMobile(_this);
        } else {
          setPipelineProgress(_this);
        }
      }, 500);
    } else {
      resetProgress(_this);
    }
  });

  // Line logic
  // let containerOffset = $('.pd-social-links').offset().left;
  // $("body").get(0).style.setProperty("--container-offset", containerOffset);
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth + "px";
  document.body.style.setProperty("--scrollbar-width", scrollbarWidth);

  // Homepage GSAP Animation
  // Only run if the slider exists
  if ($(".pd-hero-slider").length) {
    const scroller = document.querySelector("#pd-content");
    const lineV = document.querySelector("#line-v");
    const sections = document.querySelectorAll("section");

    $(".pd-scroll-bottom").append($(".site-footer"));

    ScrollTrigger.defaults({
      toggleActions: "play pause resume pause",
      scroller: scroller, //".container"
      // markers: {startColor: "green", endColor: "red", fontSize: "12px"}
    });

    gsap.to(lineV, {
      scrollTrigger: {
        trigger: ".pd-hero-slider",
        start: "top+=100 bottom-=100",
        end: "bottom bottom-=100",
        onEnter: (self) => {
          sections.forEach((section) => {
            section.classList.remove("section");
          });
          lineV.className = "";
          self.trigger.classList.add("active", "viewed");
        },
        onLeave: (self) => {
          self.trigger.classList.remove("active");
          self.trigger.classList.add("leave-back");
        },
        onEnterBack: (self) => {
          sections.forEach((section) => {
            section.classList.remove("active");
          });
          self.trigger.classList.add("active");
          lineV.className = "";
        },
        onLeaveBack: (self) => {
          self.trigger.classList.remove("leave-back");
        },
      },
    });

    gsap.to(lineV, {
      scrollTrigger: {
        trigger: ".hero-section.layout-align-center",
        start: "top+=100 bottom-=100",
        end: "bottom bottom-=100",
        onEnter: (self) => {
          sections.forEach((section) => {
            section.classList.remove("active");
          });
          lineV.className = "";
          lineV.classList.add("line-mid");
          self.trigger.classList.add("active", "viewed");
        },
        onLeave: (self) => {
          self.trigger.classList.remove("active");
          self.trigger.classList.add("leave-back");
        },
        onEnterBack: (self) => {
          sections.forEach((section) => {
            section.classList.remove("active");
          });
          self.trigger.classList.add("active");
          lineV.className = "";
          lineV.classList.add("line-mid");
        },
        onLeaveBack: (self) => {
          self.trigger.classList.remove("leave-back");
        },
      },
    });

    gsap.to(lineV, {
      scrollTrigger: {
        trigger: ".hero-section.layout-align-right",
        start: "top+=100 bottom-=100",
        end: "bottom bottom-=100",
        onEnter: (self) => {
          sections.forEach((section) => {
            section.classList.remove("active");
          });
          lineV.classList.add("line-end");
          self.trigger.classList.add("active", "viewed");
        },
        onLeave: (self) => {
          lineV.classList.add("hidden");
          self.trigger.classList.remove("active"); // checkkkk
          self.trigger.classList.add("leave-back");
        },
        onEnterBack: (self) => {
          lineV.className = "";
          lineV.classList.add("line-end");
          self.trigger.classList.add("active");
        },
        onLeaveBack: (self) => {
          lineV.classList.remove("line-end");
          self.trigger.classList.remove("active", "leave-back");
        },
      },
    });

    let postScrollSections = document.querySelectorAll(".pd-scroll");

    postScrollSections.forEach((section, i) => {
      let scrollConfig;
      scrollConfig = {
        trigger: section,
        onEnter: (self) => {
          self.trigger.classList.add("active", "viewed");
        },
      };

      ScrollTrigger.create(scrollConfig);
    });
  }

  // Interior line animations
  // if ( isDesktop ) {
  if ($(".page-header.layout-align-left").length) {
    gsap.to(".page-header", {
      scrollTrigger: {
        // trigger: ".intro-content",
        start: "top bottom-=100",
        end: "bottom top+=120",
        onEnter: () => {
          $(".page-header, .pd-left-line").addClass("active");
          // if ( isDesktop ) {
          $(".bg-line-container, .pd-right-line").addClass("inactive");
          // }
        },
        onEnterBack: () => {
          $(".page-header, .pd-left-line").addClass("active");
          // if ( isDesktop ) {
          $(".bg-line-container, .pd-right-line").addClass("inactive");
          // }
        },
        onLeave: () => {
          $(".page-header").removeClass("active");
          // if ( isDesktop ) {
          $(".bg-line-container, .pd-right-line").removeClass("inactive");
          $(".bg-line-container, .pd-right-line").addClass("active");
          // }
        },
        // onComplete: function () {
        //   console.log("foo");
        // }
      },
    });

    gsap.to(".pd-left-line", {
      scrollTrigger: {
        // trigger: ".intro-content",t
        trigger: ".pd-left-line",
        start: "top bottom-=100",
        end: "bottom top+=200",
        // markers: true,
        onEnter: () => {
          $(".page-header, .pd-left-line").addClass("active");
          // if ( isDesktop ) {
          $(".bg-line-container, .pd-right-line").addClass("inactive");
          // }
        },
        onEnterBack: () => {
          $(".page-header, .pd-left-line").addClass("active");
          // if ( isDesktop ) {
          $(".bg-line-container, .pd-right-line").addClass("inactive");
          // }
        },
        onLeave: () => {
          $(".page-header, .pd-left-line").removeClass("active");
          // if ( isDesktop ) {
          $(".bg-line-container, .pd-right-line").removeClass("inactive");
          $(".bg-line-container, .pd-right-line").addClass("active");
          // }
          // console.log('leaving');
        },
        // onComplete: function () {
        //   console.log("foo");
        // }
      },
    });

    // gsap.to(".line.line-right", {
    //   // duration: 1,
    //   scrollTrigger: {
    //     trigger: ".body-content",
    //     start: "top bottom-=100px",
    //     onEnter: ({ progress, direction, isActive }) => {
    //       $("section").removeClass("active");
    //       $(".body-content").addClass("active");
    //     }
    //   }
    // });
  }

  // }

  // Map functions
  var mapStyles = [
    {
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
      ],
    },
    {
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#616161",
        },
      ],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [
        {
          color: "#f5f5f5",
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "administrative.country",
      stylers: [
        {
          color: "#858480",
        },
        {
          visibility: "on",
        },
        {
          weight: 0.25,
        },
      ],
    },
    {
      featureType: "administrative.province",
      stylers: [
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "administrative.province",
      elementType: "geometry.fill",
      stylers: [
        {
          visibility: "simplified",
        },
        {
          weight: 2,
        },
      ],
    },
    {
      featureType: "administrative.province",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#b3b2ad",
        },
        {
          visibility: "on",
        },
        {
          weight: 1.5,
        },
      ],
    },
    {
      featureType: "poi",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#eeeeee",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.text",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#757575",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#e5e5e5",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#9e9e9e",
        },
      ],
    },
    {
      featureType: "road",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#757575",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [
        {
          color: "#dadada",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#616161",
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#9e9e9e",
        },
      ],
    },
    {
      featureType: "transit",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [
        {
          color: "#e5e5e5",
        },
      ],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [
        {
          color: "#eeeeee",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#c9c9c9",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#9e9e9e",
        },
      ],
    },
  ];

  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find(".marker");

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data("zoom") || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: mapStyles,
      disableDefaultUI: true,
      zoomControl: true,
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    var iconBase = {
      url: "/wp-content/themes/lantheus/images/gps-pin.svg",
      scaledSize: new google.maps.Size(26, 34),
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      icon: iconBase,
      map: map,
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, "click", function () {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
      // console.log(map.getZoom());

      // Case: Multiple markers.
    } else {
      // console.log(map.getZoom());
      // map.fitBounds( bounds );
      map.fitBounds(bounds, { top: 90, right: 20, bottom: 15, left: 20 });
      // map.setZoom(map.getZoom() - 2);
      // console.log(map.getZoom());
    }
  }

  // Render maps on page load.
  // $(document).ready(function(){
  $(".acf-map").each(function () {
    var map = initMap($(this));
  });
  // });

  // Warn when leaving site
  $('a[target="_blank"]:not(.non-gated)').on("click", function (e) {
    var link = $(this);

    function extractDomain(url) {
      var domain;
      //find & remove protocol (http, ftp, etc.) and get domain
      if (url.indexOf("://") > -1) {
        domain = url.split("/")[2];
      } else {
        domain = url.split("/")[0];
      }

      //find & remove port number
      domain = domain.split(":")[0];

      return domain;
    }

    // Cache this variable for re-use.
    var extractedDomain = extractDomain(link.attr("href"));
    // console.log(extractedDomain);

    // If no domain found, this must be a relative link. Return because this is a same-domain link.
    if (!extractedDomain) {
      return;
    } else if (extractedDomain === "investor.lantheus.com") {
      return;
    } else if (extractedDomain !== document.domain) {
      e.preventDefault();
      // console.log('external link click');
      // Open confirmation modal + set confirm link attribute to link target
      $("#exitModal").modal();
      $("#exitConfirm").attr("href", link.attr("href"));
      // Close modal on link click
      $("#exitConfirm").on("click", function () {
        // window.location.href = link.attr('href');
        $("#exitModal").modal("hide");
      });
    }
  });
});
